import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70076054"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "alert alert-primary space-y-2",
      role: "alert"
    }, [
      /*#__PURE__*/_createElementVNode("div", null, " Good Domains will take priority over any rules sending to junk and blocked senders. "),
      /*#__PURE__*/_createElementVNode("div", null, "Existing emails in junk will not be moved back.")
    ])
  ])
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Name")
], -1))
const _hoisted_5 = { class: "col-10" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { class: "row mt-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "mb-0",
    for: "allowSubdomains"
  }, "Allow Subdomains")
], -1))
const _hoisted_9 = { class: "col-10 flex items-center" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-gray-500" }, [
        /*#__PURE__*/_createTextVNode(" e.g. if you put \"hmrc.gov.uk\" and check this, it will allow emails from \"@hmrc.gov.uk\", \"@"),
        /*#__PURE__*/_createElementVNode("i", { class: "text-black" }, "vat"),
        /*#__PURE__*/_createTextVNode(".hmrc.gov.uk\" and so on ")
      ])
    ])
  ])
], -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 d-flex justify-content-end mt-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick", "disabled"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "w-100 domain-white-list"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Name ")
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Allow Subdomains ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortIcon = _resolveComponent("SortIcon")!
  const _component_ListView = _resolveComponent("ListView")!

  return (_openBlock(), _createBlock(_component_ListView, {
    name: _ctx.name,
    actions: _ctx.domainGreenlistActions,
    resolveState: _ctx.resolveState
  }, {
    edit: _withCtx(({ selectedItem, addItem, updateItem, deleteItem, itemName }) => [
      _hoisted_1,
      selectedItem
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  required: "",
                  "onUpdate:modelValue": ($event: any) => ((selectedItem.name) = $event)
                }, null, 8, _hoisted_6), [
                  [_vModelText, selectedItem.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "allowSubdomains",
                  "onUpdate:modelValue": ($event: any) => ((selectedItem.allowSubdomains) = $event)
                }, null, 8, _hoisted_10), [
                  [_vModelCheckbox, selectedItem.allowSubdomains]
                ])
              ])
            ]),
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (selectedItem?.id != null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-danger mr-1",
                      onClick: _withModifiers(($event: any) => (deleteItem(selectedItem.name)), ["prevent"])
                    }, " Delete " + _toDisplayString(itemName), 9, _hoisted_14))
                  : _createCommentVNode("", true),
                (selectedItem?.id == null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-primary",
                      onClick: _withModifiers(addItem, ["prevent"]),
                      disabled: selectedItem?.name && selectedItem.name.length === 0
                    }, " Add " + _toDisplayString(itemName), 9, _hoisted_15))
                  : _createCommentVNode("", true),
                (selectedItem?.id != null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "btn btn-primary",
                      onClick: _withModifiers(updateItem, ["prevent"])
                    }, " Update " + _toDisplayString(itemName), 9, _hoisted_16))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    list: _withCtx(({
        selectedItem,
        items,
        setSelected,
        deleteItem,
        setSort,
        sortBy,
        sortByDescending
      }) => [
      (items.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('Name')), ["prevent"])
                }, [
                  _hoisted_19,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "Name"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_18),
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('AllowSubdomains')), ["prevent"])
                }, [
                  _hoisted_21,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "AllowSubdomains"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_20),
                _hoisted_22
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cast(items), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id,
                  class: _normalizeClass(item.id == selectedItem?.id ? 'selected-row' : ''),
                  onClick: _withModifiers(($event: any) => (setSelected(item)), ["prevent"])
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, _toDisplayString(item.allowSubdomains ? "Yes" : "No"), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "btn btn-danger mr-1",
                      onClick: _withModifiers(($event: any) => (deleteItem(item.name, item)), ["prevent"])
                    }, " Delete ", 8, _hoisted_24)
                  ])
                ], 10, _hoisted_23))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["name", "actions", "resolveState"]))
}